export default {
  default: () => import("/Users/niko/Developer/FunAcademy/fun-academy-campus/src/layouts/default.tsx").then(m => m.default || m)
}